import apiClient from "@/api/apiClient";
import { type InsertWorkspaceInvitationEnhanced } from "@/api/resources/workspaceInvitations/types";
import { type WorkspaceInvitation } from "@/supabase.types";
import { spawnDeleteApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "workspace_invitations";
const query = "*";
export const apiConfigWorkspaceInvitations: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["email", "user_name", "workspace_name", "workspace_role"],
  sortables: ["created_at", "email", "updated_at", "user_name", "workspace_role"],
};

export const getCurrentWorkspaceInvitations = async (workspace_id: string): Promise<WorkspaceInvitation[]> => {
  const { data, error } = await apiClient.from(table).select(query).eq("workspace_id", workspace_id);
  if (error) throw error;
  return data;
};

export const getWorkspaceInvitationsInvited = async (email: string): Promise<WorkspaceInvitation[]> => {
  const { data, error } = await apiClient.from(table).select(query).eq("email", email);
  if (error) throw error;
  return data;
};

export const createWorkspaceInvitation = async ({ email, ...body }: InsertWorkspaceInvitationEnhanced) => {
  const _email = email.trim().toLowerCase();
  const response = await apiClient.functions.invoke("invite-user-to-workspace", {
    body: {
      ...body,
      email: _email,
    },
  });
  if (response.error) throw response.error;
};

export const acceptWorkspaceInvitation = async (invitation_id: string) => {
  const { error } = await apiClient.rpc("accept_workspace_invitation", { invitation_id });
  if (error) throw error;
};

export const declineWorkspaceInvitation = async (invitation_id: string) => {
  const { error } = await apiClient.rpc("decline_workspace_invitation", { invitation_id });
  if (error) throw error;
};

export const deleteWorkspaceInvitation = spawnDeleteApiFunction({ table });
